import { render, staticRenderFns } from "./ExcelFileUploader.vue?vue&type=template&id=fa1f4c08&"
import script from "./ExcelFileUploader.vue?vue&type=script&lang=js&"
export * from "./ExcelFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VLayout,VTextField})
